// @flow
import type { PriceParams } from "common/records/Price"
import type { PriceFromServer } from "booking/services/ancillaries3rd/services/types"
import Price from "common/records/Price"

export const priceMapper = (price: PriceFromServer): PriceParams => {
  const { amount, currency, base, service, service_flat, merchant } = price
  return {
    amount: Number(amount),
    currency,
    base: Number(base),
    service: Number(service),
    serviceFlat: Number(service_flat),
    merchant: Number(merchant),
  }
}

export const serverPriceMapper = (price: Price) => ({
  amount: price.amount.toString(),
  currency: price.currency.toString(),
  base: price.base.toString(),
  service: price.service.toString(),
  service_flat: price.serviceFlat.toString(),
  merchant: price.merchant.toString(),
})
